const w_base = '/';

window.addEventListener('DOMContentLoaded',function()
{
    // load polyfills for old browsers
    if(!('Promise' in window))
    {
        const myLibrary = document.createElement('script');
        myLibrary.src = w_base + 'lib/polyfills.es5.js';
        document.head.appendChild(myLibrary);
    }

    const formEl = document.getElementById('w--tortenform');
    if(formEl)
    {
        new CakeForm(formEl);
    }
});

class CakeForm
{
    constructor(el)
    {
        this.uploading = false;

        this.form = el;
        this.add_security();
        this.add_eventForm();
        this.add_eventCheckbox();
        this.totalBytes = 0;
        this.uploadedBytes = 0;

        this.uploadTable = this.form.querySelector('.w__form--upload');
        this.trHtml = this.uploadTable.querySelector('tr:last-child').innerHTML;
        this.filenames = [];
    }

    add_security()
    {
        const submitCheck = document.createElement('input');
        submitCheck.type = 'hidden';
        submitCheck.value = 'ok';
        submitCheck.name = 'submitCheck';
        this.form.appendChild(submitCheck);
    }

    add_eventCheckbox()
    {
        const mySwitch = this.form.querySelector('.condition-switch'),
              myContainer = this.form.querySelector('.w__form--conditional-container');

        if(mySwitch && myContainer)
        {
            const requiredEls = myContainer.querySelectorAll('.w__form--item[data-required="1"]');
            mySwitch.addEventListener('click', () => {
                if(mySwitch.checked)
                {
                    myContainer.classList.remove('none');
                    this.set_required(requiredEls,true);
                }
                else
                {
                    myContainer.classList.add('none');
                    this.set_required(requiredEls,false);
                }
            })
        }
    }

    add_overlay()
    {
        const overlay = document.createElement('div'),
              overlayInfo = document.createElement('div');
        this.progressbar = document.createElement('p');
        overlay.classList.add('w__form--overlay');
        overlayInfo.classList.add('w__form--overlay-info');
        overlayInfo.innerHTML = '<p>Bild(er) werden hochgeladen und Formular verschickt.<br>' +
                                'Bitte warten.</p>';
        this.progressbar.classList.add('w__form--overlay-progress');
        this.progressbar.textContent = '0 %';
        document.body.appendChild(overlay);
        overlay.appendChild(overlayInfo);
        overlayInfo.appendChild(this.progressbar);
    }

    add_eventForm()
    {
        this.form.addEventListener('submit', e => {
            if(this.check_form())
            {
                const buttons = this.uploadTable.querySelectorAll('.w__upload--delete-button');
                if(buttons.length > 0)
                {
                    e.preventDefault();

                    for(let i=0; i<buttons.length; i++)
                    {
                        const tr = buttons[i].closest('tr');
                        if(tr.myFile)
                        {
                            this.totalBytes += tr.myFile.size;
                        }
                    }

                    this.add_overlay();
                    this.find_upload();
                }
            }
            else
            {
                e.preventDefault();
            }
        });

        this.form.addEventListener('click', e => {
            const el = e.target,
                  p = el.closest('p.w__error');
            if(p)
            {
                p.classList.remove('w__error');
            }
            if(el.classList.contains('w__upload--delete-button'))
            {
                el.closest('tr').remove();
                this.add_row();
            }
        });

        this.form.addEventListener('change', e =>
        {
            const myPicker = e.target;
            if(myPicker.classList.contains('w__upload--picker'))
            {
                const parentEl = myPicker.getParent('tr');
                if(myPicker.files.length > 0 && this.uploading === false)
                {
                    const myFile = myPicker.files[0];
                    if(this.form.querySelector('.w__upload--tr[data-filename="' + myFile.name + '"]'))
                    {
                        alert("Sie haben bereits ein Bild mit diesem Dateinamen ausgewählt.");
                    }
                    else if(!myFile.type.match('(image/(jpeg|jpg|png|gif|bmp|webp))'))
                    {
                        alert("Sie können nur Bilder vom Typ JPEG (JPG), PNG, GIF, WebP oder BMP hochladen.");
                    }
                    else if(myFile.size/1024/1024 > 8)
                    {
                        alert("Die Datei ist zu groß! Bitte laden Sie nur Bilder mit weniger als 8 MB hoch.");
                    }
                    else
                    {
                        parentEl.myFile = myFile;
                        const myReader = new FileReader();
                        myReader.onload = e =>
                        {
                            this.uploading = false;
                            const td = myPicker.closest('td');
                            td.innerHTML = '';
                            parentEl.dataset.filename = myFile.name;
                            const myImg = new Image;
                            myImg.setAttribute('src', e.target.result.toString());
                            myImg.addEventListener('load', () =>
                            {
                                parentEl.querySelector('.w__upload--size')
                                        .textContent = myImg.width + 'x' + myImg.height;
                                myImg.classList.add('w__upload--preview-image');
                                parentEl.querySelector('.w__upload--preview').appendChild(myImg);
                            });
                            const deleteButton = document.createElement('button');
                            deleteButton.textContent = 'Löschen';
                            deleteButton.classList.add('w__upload--delete-button');
                            td.appendChild(deleteButton);
                            this.add_row();
                        };
                        myReader.readAsDataURL(myFile);
                    }
                }
            }
        });
    }

    add_row()
    {
        if(this.uploadTable &&
           this.uploadTable.querySelectorAll('.w__upload--tr').length < 3 &&
           this.uploadTable.querySelectorAll('.w__upload--tr[data-filename=""]').length === 0)
        {
            const tr = document.createElement('tr');
            tr.classList.add('w__upload--tr');
            tr.dataset.filename = '';
            tr.innerHTML = this.trHtml;
            this.uploadTable.appendChild(tr);
        }
    }

    find_upload()
    {
        const tempEl = this.uploadTable.querySelector('.w__upload--delete-button');
        if(tempEl)
        {
            const tr = tempEl.closest('tr');
            if(tr.dataset.filename && tr.myFile)
            {
                this.filenames[this.filenames.length] = tr.dataset.filename;
                this.start_upload(tr.myFile);
                tr.remove();
                this.form.querySelector('input[name="images"]').value = this.filenames.join('|');
            }
        }
        else
        {
            this.form.submit();
        }
    }

    start_upload(file)
    {
        let chunkSize;

        if(file.size < 131072) // 128 kB
        {
            chunkSize = 65536; // 64kB
        }
        else if(file.size < 524288) // 512 kB
        {
            chunkSize = 131072; // 128 kB
        }
        else if(file.size < 1048576) // 1 MB
        {
            chunkSize = 262144; // 256 kB
        }
        else if(file.size < 4194304) // 4 MB
        {
            chunkSize = 524288; // 512 kB;
        }
        else // > 4 MB
        {
            chunkSize = 1048576; // 1 MB
        }

        document.documentElement.classList.add('w__waiting');

        let startByte = 0,
            endByte = chunkSize,
            fileParts = [],
            fileInfo =
                {
                    fileName: file.name,
                    fileSize: file.size,
                    partCount: 0,
                    uploadedBytes: 0
                };

        fileInfo.partCount = Math.ceil(fileInfo.fileSize / chunkSize);

        for(let k = 0; k < fileInfo.partCount; k++)
        {
            fileParts[k] = file.slice(startByte, endByte);
            startByte = endByte;
            endByte = startByte + chunkSize;
        }

        // start uploading
        this.iterate_upload(0, fileInfo, fileParts);
    }

    iterate_upload(partNo, fileInfo, fileParts)
    {
        if(partNo < fileParts.length)
        {
            this.upload_part(partNo, fileParts[partNo], fileInfo).then(bytes =>
            {
                fileInfo.uploadedBytes = bytes;
                fileParts[partNo] = false;
                partNo++;
                this.iterate_upload(partNo, fileInfo, fileParts);
            }).catch(error => {
                console.error(error);
            });
        }
        else
        {
            this.uploadedBytes += fileInfo.uploadedBytes;
            this.find_upload();
        }
    }

    upload_part(partNo, part, fileInfo)
    {
        return new Promise((resolve, reject) =>
        {
            const fd = new FormData();
            fd.append("f", 'upload-cake-image');
            fd.append("fileName", fileInfo.fileName);
            fd.append("partNo", partNo);
            fd.append("partCount", fileInfo.partCount);
            fd.append("part", part);

            const myRequest = new XMLHttpRequest();
            myRequest.upload.addEventListener("progress",e =>
            {
                if(e.lengthComputable)
                {
                    let percent = Math.round((this.uploadedBytes + fileInfo.uploadedBytes + e.loaded) * 100 / this.totalBytes);
                    if(percent >= 100)
                    {
                        percent = 'Sende ...';
                    }
                    else
                    {
                        percent = percent.toString() + ' %';
                    }
                    this.progressbar.textContent = percent;
                }
            }, false);

            myRequest.addEventListener("load", e =>
            {
                const r = e.target['response'];

                if(r === "OK")
                {
                    fileInfo.uploadedBytes += part.size;
                    resolve(fileInfo.uploadedBytes);
                }
                else
                {
                    reject('Upload error');
                }

            }, false);

            myRequest.open("POST", w_base + "upload_cake_image.php");
            myRequest.setRequestHeader("Accept", "text/plain");
            myRequest.responseType = 'text';
            myRequest.send(fd);
        });
    }

    check_form()
    {
        let ok = true;
        const requiredEls = this.form.querySelectorAll('.w__form--item[required="1"]');
        for(let i=0; i<requiredEls.length; i++)
        {
            if(requiredEls[i].type === 'number' && parseInt(requiredEls[i].value) < 1 ||
               requiredEls[i].type !== 'number' && requiredEls[i].value.trim().length < 2)
            {
                if(ok === true)
                {
                    document.documentElement.scrollTo(0,0);
                }
                ok = false;
                requiredEls[i].closest('p').classList.add('w__error');
            }
            else
            {
                requiredEls[i].closest('p').classList.remove('w__error');
            }
        }
        return ok;
    }

    set_required(els, on)
    {
        for(let i=0; i<els.length; i++)
        {
            if(on === true)
            {
                els[i].setAttribute('required',"1");
            }
            else
            {
                els[i].removeAttribute('required');
            }
        }
    }
}